<template lang="pug">
  .dividingLine-container(:class="[spacingTop, spacingBottom]")
    div.container.mx-auto
      hr
</template>

<script>
export default {
    name: 'DividingLine',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    computed: {
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

hr
  @apply border-0
  height: 2px
  background-color: #ccc
</style>
